import { DiscoveryApi, FetchApi } from "@backstage/core-plugin-api";

export type AuthResponse = {
    refresh_token_expires_in: string;
    api_product_list: string;
    api_product_list_json: string[];
    organization_name: string;
    "developer.email": string;
    token_type: string;
    issued_at: string;
    client_id: string;
    access_token: string;
    application_name: string;
    scope: string;
    expires_in: string;
    refresh_count: string;
    status: string;
  };

export class SetCookieClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor({
    discoveryApi,
    fetchApi,
  }: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  async getCookie(): Promise<AuthResponse> {
    const apiUrl = `${await this.discoveryApi.getBaseUrl('proxy')}/authenticate_oauth/authenticate?grant_type=client_credentials`;

    const requestOptions: RequestInit = {
      method: 'POST',
      body: new URLSearchParams({ grant_type: 'client_credentials' }).toString(),
      redirect: 'follow',
    };

    const response = await this.fetchApi.fetch(apiUrl, requestOptions);
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    return response.json(); // Assuming the API returns JSON
  }
}
